export default {
  name: 'marking--importThirdCountryP',
  apiService: 'shoes',
  apiPath: '/admin/import_p',
};
